import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'app/app.constants';
import { PasswordValidationEnum } from 'app/core/enum/password-validation.enum';
import { TimeoutEnum } from 'app/core/enum/timeout.enum';
import { UserService } from 'app/core/services/user.service';
import { resolveLocalizedLink } from 'app/utils/localized-link.utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-reset',
  templateUrl: 'reset.component.html',
  styleUrls: ['reset.scss'],
})
export class ResetPasswordComponent implements OnInit {
  finishedRegistration = false;
  invalidHash = false;
  currentYear: number;
  blockBtnReset = false;
  sendSuccess = false;
  newPasswordForm: UntypedFormGroup;
  displayMessage: { [key: string]: string } = {};
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;

  /** "About us" page of the company site, in the app language. */
  get aboutLink(): string {
    return resolveLocalizedLink(
      AppConstants.EXTERNAL_LINKS.COMPANY_ABOUT,
      this.translate.currentLang,
    );
  }

  constructor(
    public router: Router,
    public fb: UntypedFormBuilder,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public userService: UserService,
    public http: HttpClient,
    private readonly toastr: ToastrService,
  ) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const hash = params['hash'];

      if (hash === null || hash === '') {
        this.router.navigateByUrl('/login');
      }
    });
    this.newPasswordForm = this.fb.group({
      Senha: ['', [Validators.required]],
      ConfirmarSenha: ['', [Validators.required]],
    });
  }

  newPassword() {
    this.toastr.clear();

    if (this.validateField()) {
      this.sendSuccess = true;
      this.blockBtnReset = false;
      this.route.queryParams.subscribe((params) => {
        const hash = params['hash'];
        const password = this.newPasswordForm.controls.Senha.value;
        this.userService.redefinirSenha(password, hash).subscribe(
          (_) => {
            this.translate
              .get('global.alert.password-success')
              .subscribe((res: string) => {
                this.toastr.success(res, '', {
                  positionClass: 'toast-top-full-width',
                  disableTimeOut: false,
                });
                this.blockBtnReset = false;
                this.sendSuccess = false;
                setTimeout(() => {
                  this.router.navigate(['login']);
                }, TimeoutEnum.Medium);
              });
          },
          (error) => {
            this.translate
              .get('global.validate.email.required')
              .subscribe((res: string) => {
                this.toastr.error(res, '', {
                  positionClass: 'toast-top-full-width',
                  disableTimeOut: false,
                });
                this.blockBtnReset = true;
                this.sendSuccess = true;
              });

            if (
              error.error.text === this.translate.get('forgot.title-hash-reset')
            ) {
              this.translate
                .get('global.alert.password-reset-used')
                .subscribe((res: string) => {
                  this.toastr.warning(res, '', {
                    positionClass: 'toast-top-full-width',
                    disableTimeOut: false,
                  });
                });
            } else {
              this.translate
                .get('global.alert.password-reset-error-message')
                .subscribe((res: string) => {
                  this.toastr.warning(res, '', {
                    positionClass: 'toast-top-full-width',
                    disableTimeOut: false,
                  });
                });
            }
          },
        );
      });
    } else {
      this.blockBtnReset = false;
    }
  }

  validateField() {
    this.blockBtnReset = true;
    let isValid = true;

    if (
      this.newPasswordForm.controls.Senha.value.length <
      PasswordValidationEnum.MinLength
    ) {
      this.translate
        .get('global.validate.password-minlength')
        .subscribe((res: string) => {
          this.toastr.warning(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
        });
      isValid = false;
    }

    if (
      this.newPasswordForm.controls.Senha.value !==
      this.newPasswordForm.controls.ConfirmarSenha.value
    ) {
      this.translate
        .get('global.validate.password-wrong')
        .subscribe((res: string) => {
          this.toastr.warning(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
        });
      isValid = false;
    }

    this.blockBtnReset = !isValid;
    return isValid;
  }

  togglePassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleConfirmPassword() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  irParaLogin() {
    this.toastr.clear();
    this.router.navigateByUrl('/login');
  }

  verifyMaxLength(event) {
    if (event.target.value.length === PasswordValidationEnum.MaxLength) {
      this.translate
        .get('global.validate.password-maxlength')
        .subscribe((res: string) => {
          this.toastr.warning(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
        });
    }
  }
}
